import { create } from 'zustand';

export const useGroupDetailsData = create((set) => ({
  groupDetailsData: null,
  setGroupDetailsData: (data: any) => set(() => ({ groupDetailsData: data }))
}));

export const useGroupData = create((set) => ({
  groupData: {
    analyzeGroup: [],
    compareGroup: []
  },
  setGroupData: (data: any) => set(() => ({ groupData: data }))
}));

export const useFilterApplied = create((set) => ({
  filterApplied: false,
  setFilterApplied: (isFilterApplied: boolean) => set(() => ({ filterApplied: isFilterApplied }))
}));

export const useComparisonFilterApplied = create((set) => ({
  comparisonFilterApplied: false,
  setComparisonFilterApplied: (isComparisonFilterApplied: boolean) =>
    set(() => ({ comparisonFilterApplied: isComparisonFilterApplied }))
}));

export const useButtonGoStatus = create((set) => ({
  isClicked: false,
  setIsClicked: (doClick: boolean) => set(() => ({ isClicked: doClick }))
}));

export const useClearSelection = create((set) => ({
  clearSelection: false,
  setClearSelection: (applied: boolean) => set(() => ({ clearSelection: applied }))
}));

export const useShowLoader = create((set) => ({
  show: false,
  setShow: (shouldShow: boolean) => set(() => ({ isClicked: shouldShow }))
}));

export const useFilters360Box = create((set) => ({
  filters: [],
  setFilters: (data: any) => set(() => ({ filters: data }))
}));

export const useFiltersComparisonBox = create((set) => ({
  filters: [],
  setFilters: (data: any) => set(() => ({ filters: data }))
}));

export const useGroupDetailsShowed = create((set) => ({
  isShown: false,
  setIsShown: (show: boolean) => set(() => ({ isShown: show }))
}));

export const useAnalysisFilterClicked = create((set) => ({
  isClicked: false,
  setIsClicked: (click: boolean) => set(() => ({ isClicked: click }))
}));

export const useComparisonFilterClicked = create((set) => ({
  isClicked: false,
  setIsClicked: (click: boolean) => set(() => ({ isClicked: click }))
}));

export const use360ViewsData = create((set) => ({
  viewDataSelected: [],
  setViewDataSelected: (data: any[]) => set(() => ({ viewDataSelected: data }))
}));

export const use360AnalysisCounter = create((set) => ({
  pctCounter: null,
  setPctCounter: (data: any) => set(() => ({ pctCounter: data }))
}));

export const use360ComparisonCounter = create((set) => ({
  pctCounter: null,
  setPctCounter: (data: any) => set(() => ({ pctCounter: data }))
}));

export const use360AnalysisFilters = create((set) => ({
  filters: null,
  setFilters: (data: any) => set(() => ({ filters: data }))
}));

export const use360ComparisonFilters = create((set) => ({
  filters: null,
  setFilters: (data: any) => set(() => ({ filters: data }))
}));

export const use360GroupDefaultDetailsData = create((set) => ({
  groupDefaultDetailsData: null,
  setGroupDefaultDetailsData: (data: any) => set(() => ({ groupDefaultDetailsData: data }))
}));

export const use360GroupDetailsData = create((set) => ({
  groupDetailsData: null,
  setGroupDetailsData: (data: any) => set(() => ({ groupDetailsData: data }))
}));

export const use360GroupDetailsDataAsc = create((set) => ({
  groupDetailsData: null,
  setGroupDetailsData: (data: any) => set(() => ({ groupDetailsData: data }))
}));

export const use360GroupDetailsDataMinWeight = create((set) => ({
  groupDetailsData: null,
  setGroupDetailsData: (data: any) => set(() => ({ groupDetailsData: data }))
}));

export const use360GroupDetailsDataAscMinWeight = create((set) => ({
  groupDetailsData: null,
  setGroupDetailsData: (data: any) => set(() => ({ groupDetailsData: data }))
}));

export const use360DefaultChecked = create((set) => ({
  defaultChecked: 'default',
  setDefaultChecked: (checked: string) => set(() => ({ defaultChecked: checked }))
}));

export const use360DisplayToggle = create((set) => ({
  enabledToggle: false, // true,
  setEnabledToggle: (checked: boolean) => set(() => ({ enabledToggle: checked }))
}));

export const use360DisplayChecked = create((set) => ({
  differentiatedChecked: 'any-radio',
  setDifferentiatedChecked: (type: string) => set(() => ({ differentiatedChecked: type }))
}));

export const useRemoveSingleFilterAnalysis = create((set) => ({
  removed: false,
  setRemoved: (isFilterApplied: boolean) => set(() => ({ removed: isFilterApplied }))
}));

export const useViewRemovedSingleFilterAnalysis = create((set) => ({
  value: undefined,
  setValue: (view: string) => set(() => ({ value: view }))
}));

export const useRemoveAllFiltersAnalysis = create((set) => ({
  removed: false,
  setRemoved: (isFilterApplied: boolean) => set(() => ({ removed: isFilterApplied }))
}));

export const useViewRemovedAllFilterAnalysis = create((set) => ({
  viewRemoved: undefined,
  setViewRemoved: (view: string) => set(() => ({ viewRemoved: view }))
}));

export const useRemoveSingleFilterComparison = create((set) => ({
  removed: false,
  setRemoved: (isFilterApplied: boolean) => set(() => ({ removed: isFilterApplied }))
}));

export const useViewRemovedSingleFilterComparison = create((set) => ({
  value: undefined,
  setValue: (view: string) => set(() => ({ value: view }))
}));

export const useRemoveAllFiltersComparison = create((set) => ({
  removed: false,
  setRemoved: (isFilterApplied: boolean) => set(() => ({ removed: isFilterApplied }))
}));

export const useViewRemovedAllFilterComparison = create((set) => ({
  viewRemoved: undefined,
  setViewRemoved: (view: string) => set(() => ({ viewRemoved: view }))
}));

export const useCohortDateFormatData = create((set) => ({
  dateCohortData: undefined,
  setDateCohortData: (data: any) => set(() => ({ dateCohortData: data }))
}));

export const useWidthDetailsCohort = create((set) => ({
  width: 0,
  setWidth: (data: any) => set(() => ({ width: data }))
}));

export const use360ValuesUpdatedFromAI = create((set) => ({
  updated: false,
  setUpdated: (isUpdated: boolean) => set(() => ({ updated: isUpdated }))
}));

export const use360AnalysisFiltersStored = create((set) => ({
  filters: null,
  setFilters: (data: any) => set(() => ({ filters: data }))
}));

export const use360ComparisonFiltersStored = create((set) => ({
  filters: null,
  setFilters: (data: any) => set(() => ({ filters: data }))
}));

export const useGetTotalItems = create((set) => ({
  data: null,
  setData: (data: any) => set(() => ({ data: data }))
}));

export const usePayloadAIExplainerCohorts = create((set) => ({
  data: null,
  setData: (data: any) => set(() => ({ data: data }))
}));

export const useShowAIExplainerCohorts = create((set) => ({
  showExplainer: false,
  setShowExplainer: (showExplainer: boolean) => set(() => ({ showExplainer: showExplainer }))
}));

export const useAIExplainerCohorts = create((set) => ({
  explainer: '',
  setExplainer: (explainer: string) => set(() => ({ explainer: explainer }))
}));

export const useAIExplainerCohortsArray = create((set) => ({
  explainer: [],
  setExplainer: (explainer: any) => set(() => ({ explainer: explainer }))
}));

export const use360PvalueChecked = create((set) => ({
  checked: 'max',
  setChecked: (checked: string) => set(() => ({ checked: checked }))
}));

export const useIncludeNoAnswers = create((set) => ({
  include: true,
  setInclude: (include: boolean) => set(() => ({ include: include }))
}));

export const useScrollingCohorts = create((set) => ({
  scrolling: false,
  setScrolling: (scrolling: boolean) => set(() => ({ scrolling: scrolling }))
}));

export const useShowViews = create((set) => ({
  views: [],
  setViews: (views: any) => set(() => ({ views: views }))
}));

export const useSortAnalysisGroup = create((set) => ({
  sortBy: 'default',
  setDefaultBy: (sortBy: string) => set(() => ({ sortBy: sortBy }))
}));

export const useSortComparisonGroup = create((set) => ({
  sortBy: 'default',
  setDefaultBy: (sortBy: string) => set(() => ({ sortBy: sortBy }))
}));

export const useSortBy = create((set) => ({
  sortByTo: '',
  setSortyByTo: (sortByTo: string) => set(() => ({ sortByTo: sortByTo }))
}));

export const useComparativeShowLoader = create((set) => ({
  showLoader: true,
  setShowLoader: (showLoader: boolean) => set(() => ({ showLoader: showLoader }))
}));

export const useComparativeShowGroupDetails = create((set) => ({
  showGroupsDetails: false,
  setShowGroupsDetails: (showGroupsDetails: boolean) =>
    set(() => ({ showGroupsDetails: showGroupsDetails }))
}));

interface ComparisonState {
  computeOverlap: boolean;
  filters: any[];
}
interface ComparisonStore {
  comparison: ComparisonState | null;
  setComparison: (filters: any[]) => void;
  clearComparison: () => void;
}
export const useComparisonStore = create<ComparisonStore>((set) => ({
  comparison: null,
  setComparison: (filters) =>
    set({
      comparison: {
        computeOverlap: true,
        filters: filters
      }
    }),
  clearComparison: () => set({ comparison: null })
}));
